import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import arCharger from './assets/locales/ar/charger.json';
import arHyperPay from './assets/locales/ar/hyperPay.json';
import arRedirect from './assets/locales/ar/redirect.json';
import enCharger from './assets/locales/en/charger.json';
import enHyperPay from './assets/locales/en/hyperPay.json';
import enRedirect from './assets/locales/en/redirect.json';
import frCharger from './assets/locales/fr/charger.json';
import frHyperPay from './assets/locales/fr/hyperPay.json';
import frRedirect from './assets/locales/fr/redirect.json';
import spCharger from './assets/locales/sp/charger.json';
import spHyperPay from './assets/locales/sp/hyperPay.json';
import spRedirect from './assets/locales/sp/redirect.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        redirect: enRedirect,
        hyperPay: enHyperPay,
        charger: enCharger,
      },
      ar: {
        redirect: arRedirect,
        hyperPay: arHyperPay,
        charger: arCharger,
      },
      sp: {
        redirect: spRedirect,
        hyperPay: spHyperPay,
        charger: spCharger,
      },
      fr: {
        redirect: frRedirect,
        hyperPay: frHyperPay,
        charger: frCharger,
      },
    },
    // Only enable languages that exist in resources
    supportedLngs: ['en', 'ar', 'sp', 'fr'],
    fallbackLng: 'en',
    detection: {
      order: [
        'querystring',
        'cookie',
        'localStorage',
        'sessionStorage',
        'htmlTag',
        'path',
        'subdomain',
      ],
      caches: ['cookie'],
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
    },
    // Must match useTranslation namespace
    ns: ['redirect', 'charger', 'hyperPay'],
    defaultNS: 'redirect',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
